import React from 'react';

function CheckCircle({ filled, ...props }) {
    return filled ? (React.createElement("svg", { "aria-hidden": "true", focusable: "false", role: "img", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("path", { fill: "currentColor", d: "M10 0a10 10 0 110 20 10 10 0 010-20zm3.3 6.3l-4.8 4.3-1.8-1.8-1.4 1.4 3.2 3.2 6.2-5.7z" }))) : (React.createElement("svg", { "aria-hidden": "true", focusable: "false", role: "img", viewBox: "0 0 127 127", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", transform: "translate(3 3)" },
            React.createElement("circle", { cx: "60.5", cy: "60.5", r: "60.5", strokeWidth: "5" }),
            React.createElement("path", { d: "M37 54l15 21 31-29", strokeWidth: "8" }))));
}

export { CheckCircle as default };
//# sourceMappingURL=CheckCircle.js.map
